import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';
import authRoutes from './authRoutes';
import Layout from './components/layout';
import PageLoader from './components/loaders/PageLoader';
import ErrorBoundaryComponent from './errorboundary';
import PrivateRoutes from './helpers/PrivateRoutes';
import routes from './routes';

const App = () => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryComponent}
      // eslint-disable-next-line no-return-assign
      onReset={() => (window.location.href = '/dashboard')}
    >
      <Routes>
        {authRoutes.map((route, index) => {
          return route.component ? (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<PageLoader />}>
                  <route.component />
                </Suspense>
              }
            />
          ) : null;
        })}
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<Layout />}>
            {routes.map((route, index) => {
              return route.component ? (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <Suspense fallback={<PageLoader />}>
                      <route.component />
                    </Suspense>
                  }
                />
              ) : null;
            })}
          </Route>
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default App;
